var map = {
	"./affidabilita.png": "./app/javascript/assets/images/aws_connect/affidabilita.png",
	"./eccellenza.png": "./app/javascript/assets/images/aws_connect/eccellenza.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/assets/images/aws_connect sync recursive \\.(png|jpe?g|svg)$";